var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 377.64 434.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b53a39f7-d270-4b6a-96de-5ad84955f4de",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5dcc38f-80f1-4580-b953-18304d74f2fc",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.56,175.21c8.38,9.83,14.17,20.53,16.27,33.09,2.79,16.75-1.75,31.62-11.29,45.28-8,11.53-18.87,19.73-30.85,26.78-9.46,5.57-18.61,11.69-27.85,17.63Q213,358.22,119.27,418.48C107.49,426.05,95,432,81.05,434.05c-13.52,2-26.15-.29-37.14-8.93C35.57,418.58,30.57,409.75,27,400c-1-2.65.18-4,2.34-5.44Q78.91,361.82,128.39,329L357,177.45C358.05,176.76,359.11,176.12,360.56,175.21Z",
    style: {
      fill: "#798bff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57,258.73l-9.68-6.83-69.4,45.44c0-3.63-.27-6.42.14-9.12.15-1,1.79-1.92,2.9-2.66q46.26-30.63,92.55-61.21Q195.56,172.5,274,120.58c2.94-2,5.18-2.32,7.91-.18a42.07,42.07,0,0,0,4,2.43l-12.9,9c3.32,2.18,6.11,4.25,9.14,5.84.81.43,2.56-.28,3.57-.94,9.1-5.95,18.12-12,27.2-18,2.15-1.42,4.44-2.64,6.66-4l.79,1L304,134c15.3,10.89,32,19.34,46.69,31.71L22.81,382.84c-.47-4.27-1.15-7.82-1.2-11.37-.18-13.5-.17-27-.22-40.49,0-5.5.15-11-.06-16.49-.1-2.61.86-4.05,3-5.43q36.08-23.61,72-47.38C97.56,260.88,98.74,260,100.57,258.73ZM185.77,203c-2.83-1.87-5.27-3.31-7.49-5-2-1.53-3.5-1.42-5.62,0-21.49,14.34-43.06,28.55-64.59,42.82-1,.64-1.86,1.42-3.14,2.41L115.21,250Zm73.77-62.63-70.77,47c2.83,1.87,5.22,3.22,7.33,4.92s3.73,1.43,5.93,0q32.55-21.72,65.24-43.25c.67-.45,1.25-1,2.27-1.89Z",
    style: {
      fill: "#798bff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.92,195.68c-.13-1.58-.27-2.42-.27-3.25q0-65.81.14-131.6a91.42,91.42,0,0,1,5-29.8c7-20.21,25.88-32.44,47.55-30.9a78.46,78.46,0,0,1,36.3,12C136,26.7,159.11,41.5,182.32,56.23c8.54,5.41,17,10.88,26.26,16.77Z",
    style: {
      fill: "#798bff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,111.72.54,288.33,0,287.65c3.9-4.71,7.81-9.42,11.68-14.16,3.17-3.86,7.47-7.32,9.09-11.76s.59-9.85.61-14.83c0-10.5.12-21-.06-31.49-.05-2.87.92-4.47,3.28-6q91.82-60.55,183.53-121.26c3.12-2.06,6.28-4.08,9.37-6.2a3,3,0,0,1,3.73-.15Q244,96.26,266.82,110.63C267,110.75,267.12,111,267.64,111.72Z",
    style: {
      fill: "#798bff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolBlue);
export default __webpack_public_path__ + "static/media/symbol-blue.ee49cc715d78c7e434b27b50fe434c93.svg";
export { ForwardRef as ReactComponent };